import { FormatIcu } from '@tolgee/format-icu';
import { DevTools, Tolgee } from '@tolgee/react';
import csMessages from './messages/cs.json';
import enMessages from './messages/en.json';

const isDev = process.env.NODE_ENV === 'development';

export const tolgee = Tolgee()
  .use(FormatIcu())
  .use(isDev ? DevTools() : undefined)
  .init({
    language: 'cs',
    fallbackLanguage: 'en',

    // Tolgee Cloud — API key needed for in-context editing in dev
    apiUrl: 'https://app.tolgee.io',
    apiKey: isDev ? (process.env.TOLGEE_API_KEY ?? '') : undefined,

    // Static data from local JSON (used in production + as fallback in dev)
    staticData: {
      cs: csMessages,
      en: enMessages,
    },

    // Available languages
    availableLanguages: ['cs', 'en', 'sk', 'de', 'pl', 'hu'],
  });
